export const ReservationMode = {
  NOT_ACCEPT: 0, // 予約不可
  ACCEPT: 1, // 予約可能
  REQUEST: 2, // リクエスト予約
  TEL: 3, // 電話問い合わせ
};
